var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.budgetLoaded)?_c('budget-detail-team-members-table',{attrs:{"tableMode":'team'}}):_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }